import { useState } from 'react'
import { AddButton } from '@/components/common/AddButton'
import type { StatusTrack, StatusTrackValue } from '@/features/contract/statuses/types'
import { ValuesList } from './ValuesList'
import { ValueFormDialog } from './ValueFormDialog'

export function TrackEditorPanel({ track }: { track: StatusTrack }) {
  const [creating, setCreating] = useState(false)
  const [editing, setEditing] = useState<StatusTrackValue | null>(null)

  return (
    <main className="flex-1 flex flex-col overflow-hidden">
      <header className="px-4 py-3 border-b flex items-center justify-between">
        <div>
          <h2 className="text-base font-semibold">{track.labelPl}</h2>
          <p className="text-xs text-slate-500 font-mono">
            {track.code} · {track.isActive ? 'aktywny' : 'nieaktywny'}
          </p>
        </div>
<AddButton onClick={() => setCreating(true)}>Dodaj wartość</AddButton>
      </header>
      <div className="flex-1 overflow-auto px-4 py-3">
        <ValuesList trackId={track.id} values={track.values} onEdit={setEditing} />
      </div>
      {(creating || editing) && (
        <ValueFormDialog
          trackId={track.id}
          editing={editing}
          onClose={() => { setCreating(false); setEditing(null) }}
        />
      )}
    </main>
  )
}
